import { Button } from 'antd';
import React, { FC } from 'react';
import StyledWrapper from './styles';

type Props = {
  height: string;
  width: string;
  title?: string;
  titleButton: string;
  action?: () => void;
};

const ButtonSubmit: FC<Props> = ({ action, titleButton, title, height, width }) => {
  const divTitle = () => {
    return title ? <div className="standardBoldFont text">{title}</div> : '';
  };
  return (
    <StyledWrapper>
      {divTitle()}
      <Button
        className="btn1 standardBoldFont"
        onClick={action}
        style={{
          width: width,
          height: height,
          color: 'white',
          boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.2)',
          borderRadius: '5px',
        }}
        htmlType="submit"
      >
        {titleButton}
      </Button>
    </StyledWrapper>
  );
};

export default ButtonSubmit;
